import React from 'react';
import { Description, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const HERO_TEXT_D = buildImageURL('/hero-text-d.png');
const HERO_TEXT_M = buildImageURL('/hero-text-d.png');
const HERO_IMG_D = buildImageURL('/hero-img-d.jpg');
const HERO_IMG_M = buildImageURL('/hero-img-m.jpg');

const track = getTrack({ block: 1 });

export function HeroPlus({ mobile = false }) {
  return (
    <div className="page-section section-hero inverted" data-track={track}>
      {/*<Image className="hero-text" src={mobile ? HERO_TEXT_M : HERO_TEXT_D} />*/}
      <Description>*后置双主摄包含GN1超感光主摄、超广角微云台主摄。<br/>*产品图片仅供参考，请以实物为准。</Description>
      <Image className="hero-img" src={mobile ? HERO_IMG_M : HERO_IMG_D} />
    </div>
  )
}

